import { PathHop } from '@/features/application/types/forms';

/**
 * Converts a PathHop array to a human-readable string representation
 * Skips the anchor hop and formats locators appropriately
 */
export const pathToString = (path: PathHop[]): string => {
  if (!path || path.length === 0) return '';

  return path
    .filter((hop) => hop.rel) // Skip anchor hop (no rel)
    .map((hop) => {
      let hopString = hop.rel || hop.object;
      if (hop.locator) {
        if (hop.locator.strategy === 'fieldValue') {
          const entries = Object.entries(hop.locator.params || {});
          if (entries.length > 0) {
            const [key, value] = entries[0];
            hopString += `[${key}=${value}]`;
          }
        } else if (hop.locator.strategy === 'positional') {
          hopString += `[${hop.locator.params.index || 0}]`;
        }
      }
      return hopString;
    })
    .join('.');
};

/**
 * Checks if a path has any hops defined (beyond the anchor)
 */
export const hasPathHops = (path: PathHop[]): boolean => {
  return path && path.length > 0 && path.some((hop) => hop.rel);
};
